import Class from './c-tabs';
import './c-tabs@';

export default Class;